/* expanding-panels.js — PRD §5.2
   Desktop pointer only: three doors expand to 50/25/25 via flex-basis.
   Keyboard focus fires the same expansion. Nothing scales, lifts or moves.
   Labels are permanently visible and owe nothing to this file. */

(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 1024px)');
  var CAN_HOVER = window.matchMedia('(hover: hover)');

  function Doors(root) {
    this.root = root;
    this.panels = Array.prototype.slice.call(root.querySelectorAll('[data-ag-door]'));
    if (this.panels.length < 2) return;
    this.bind();
  }

  Doors.prototype.engage = function (panel) {
    if (!DESKTOP.matches) return;
    this.root.classList.add('is-engaged');
    this.panels.forEach(function (p) {
      p.classList.toggle('is-expanded', p === panel);
    });
  };

  Doors.prototype.release = function () {
    this.root.classList.remove('is-engaged');
    this.panels.forEach(function (p) { p.classList.remove('is-expanded'); });
  };

  Doors.prototype.bind = function () {
    var self = this;

    this.panels.forEach(function (panel) {
      if (CAN_HOVER.matches) {
        panel.addEventListener('mouseenter', function () { self.engage(panel); });
      }
      // Keyboard parity — focus produces the same expansion (§5.2)
      panel.addEventListener('focus', function () { self.engage(panel); });
    });

    if (CAN_HOVER.matches) {
      this.root.addEventListener('mouseleave', function () { self.release(); });
    }
    this.root.addEventListener('focusout', function (e) {
      if (!self.root.contains(e.relatedTarget)) self.release();
    });

    DESKTOP.addEventListener('change', function (e) {
      if (!e.matches) self.release();
    });
  };

  function init() {
    document.querySelectorAll('[data-ag-doors]').forEach(function (el) {
      if (!el.agDoors) el.agDoors = new Doors(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
